module.exports = __webpack_public_path__ + "img/lg_ring_r_l_null_1.3aac62cd.png";